export class CampaignTrackEventRequest {
  event: string;
  constructor(event: string) {
    this.event = event;
  }
}

export class CampaignTrackEventType {
  public static readonly VIEW = 'view';
  public static readonly CLICK = 'click';
}


// WEBPACK FOOTER //
// ./src/app/services/promotion/payload/campaign.model.ts